import { FC } from 'react';
import { ModalComponent } from 'components/Modal';
import { CheckCircle } from 'components/Icons/CheckCircle';

const STEPS = [
  { label: 'Stripe Onboarding Complete' },
  { label: 'Account Verified' },
  { label: 'First Donation Received' },
];

interface ProfileProgressModalProps {
  isOpen: boolean;
  onClose: () => void;
  stepOneComplete: boolean;
  stepTwoComplete: boolean;
  stepThreeComplete: boolean;
}

export const ProfileProgressModal: FC<ProfileProgressModalProps> = ({
  isOpen,
  onClose,
  stepOneComplete,
  stepTwoComplete,
  stepThreeComplete,
}) => {
  const steps = [stepOneComplete, stepTwoComplete, stepThreeComplete];
  const completedCount = steps.filter(Boolean).length;
  const isComplete = completedCount === STEPS.length;

  return (
    <ModalComponent isOpen={isOpen} closeModal={onClose}>
      <div className="profile-progress-modal">
        <span className="profile-progress-modal__title">
          {isComplete ? 'Your profile is complete!' : 'Your profile is almost complete'}
        </span>
        <span className="profile-progress-modal__subtitle">
          Complete these {STEPS.length} steps:
        </span>

        <div className="profile-progress-modal__steps">
          {STEPS.map((step, i) => {
            const isStepComplete = steps[i];
            return (
              <div key={step.label} className="profile-progress-modal__step">
                <span className="profile-progress-modal__step-icon">
                  {isStepComplete ? (
                    <CheckCircle size={28} />
                  ) : (
                    <span className="profile-progress-modal__empty-circle" aria-hidden="true" />
                  )}
                </span>
                <span className="profile-progress-modal__step-label">Step {i + 1}</span>
                <span className="profile-progress-modal__step-description">{step.label}</span>
              </div>
            );
          })}
        </div>

        <button type="button" className="profile-progress-modal__button" onClick={onClose}>
          Got it!
        </button>
      </div>
    </ModalComponent>
  );
};
